import '../../utils/highlight';
import ReactQuill from 'react-quill';
import { useState } from 'react';
//
import { EditorProps } from './types';
import { StyledEditor } from './styles';
import EditorToolbar, { formats } from './EditorToolbar';

// ----------------------------------------------------------------------

export default function Editor({
  id = 'minimal-quill',
  error,
  value,
  onChange,
  simple = false,
  helperText,
  sx,
  ...other
}: EditorProps) {
  const [isCodeView, setIsCodeView] = useState(false);
  
  const handleToggleCodeView = () => {
    // Используем функциональное обновление состояния
    setIsCodeView(prev => !prev);
  };
  
  const modules = {
    toolbar: {
      container: `#${id}`,
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true,
    },
    syntax: true,
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <>
      <StyledEditor
        sx={{
          ...(error && {
            border: (theme) => `solid 1px ${theme.palette.error.main}`,
          }),
          ...sx,
        }}
      >
        <EditorToolbar id={id} isSimple={simple} onToggleCodeView={handleToggleCodeView} />

        <div style={{ display: isCodeView ? 'block' : 'none' }}>
          <textarea
            value={typeof value === 'string' ? value : ''}
            onChange={(e) => onChange && onChange(e.target.value, null as any, null as any, null as any)}
            style={{
              width: '100%',
              height: '200px',
              fontFamily: 'monospace',
              fontSize: '14px',
              padding: '12px',
              border: '1px solid #ccc',
              borderTop: 'none',
              resize: 'vertical',
              outline: 'none',
              boxSizing: 'border-box'
            }}
            placeholder="HTML код..."
          />
        </div>
        
        <div style={{ display: isCodeView ? 'none' : 'block' }}>
          <ReactQuill
            value={value}
            onChange={onChange}
            modules={modules}
            formats={formats}
            placeholder="Write something awesome..."
            {...other}
          />
        </div>
      </StyledEditor>

      {helperText && helperText}
    </>
  );
}
